export default function Django_Create_AWS_Account() {
  return <div>Django_Create_AWS_Account Component</div>;
}
